<template>
    <div class="svg-line"
        v-bind:style="{left:leftShift+'px'}"
    >
        <svg xmlns="http://www.w3.org/2000/svg"
             :style="{ width: length + 'px' , height: height + 'px' }"
        >
            <path stroke="#42b7e5" stroke-width="1" fill="transparent"
            v-bind:d="d"
            />
        </svg>
    </div>
</template>

<script>
    export default {
        name: "SvgLine",
        props: ['svgl'],
        data() {
            return {
                height:100,
                front:true,
                leftShift:0,
                length:200,
                d:""
                // d:"M1,0 C1,70 100,30 100,100"

            }
        },
        watch:{
            'svgl'(){

                this.createPath();
            }
        },
        mounted() {
            this.createPath();
        },
        updated(){
            this.createPath();
        },
        methods: {
            createPath(){


                if (this.svgl.from< this.svgl.to){
                    this.leftShift=this.svgl.from;
                    this.length = this.svgl.to-this.svgl.from;
                    var W = this.svgl.to-this.svgl.from;
                    this.d = "M1,0 C1,50 " + W + ",50 " + W + "," + this.height;
                }else{
                    this.leftShift=this.svgl.to;
                    this.length = this.svgl.from-this.svgl.to+2;
                    var W = this.svgl.from-this.svgl.to+1;
                    this.d = "M" + W + ",0 C" + W + ",50 0,50 0," + this.height;
                }
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>